'use client';

import { useTranslation } from 'next-i18next';
import { LinkStyled } from '@components/common';
import { useAuthClient } from '@root/src/hooks';

/**
 * @description Offer Page Add job banner
 */
export const OfferPageAddJobBanner = () => {
  const { t } = useTranslation('common');

  const { isSafeAuth } = useAuthClient();
  const destinationPath = '/job-add/edit';

  return (
    <div>
      <div className="flex flex-col items-center justify-between py-2 md:flex-row">
        <h2 className="text-lg font-bold">{t('company.offer.job.banner.title')}</h2>

        <LinkStyled
          size="sm"
          color="secondary"
          styling="solid"
          rounding="full"
          className=""
          href={isSafeAuth
            ? destinationPath
            : `/login?targetPath=${encodeURIComponent(destinationPath)}`}
        >
          {t('header.label.add_jobs')}
        </LinkStyled>
      </div>

    </div>
  );
};
